import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OrganizationSummary } from '../../../../Models/backoffice/organization-summary.model';

@Component({
  selector: 'av-organization-picker',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './av-organization-picker.component.html',
  styleUrl: './av-organization-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class AvOrganizationPickerComponent {
  readonly organizations = input.required<OrganizationSummary[]>();
  readonly value = input<string>('');
  readonly label = input<string>('backoffice.common.organization_picker.label');
  readonly emptyLabel = input<string>('backoffice.common.organization_picker.empty');
  readonly disabled = input<boolean>(false);

  readonly valueChange = output<string>();

  select(value: string): void {
    this.valueChange.emit(value);
  }
}
